import { FunctionComponent } from 'react'

import { AppProps } from 'next/app'

import { enhanceComponentWithErrorBoundary } from '@utils/sentry'
import Header from '@components/Header'
import PianoFooterBanner from '@components/PianoFooterBanner'

import { CatchAllPageServerProps } from '../../pages/[[...pageUrl]]'

export interface BlickPlusOfferPageProps {
  Component: AppProps['Component']
  restOfPageProps?: Partial<CatchAllPageServerProps>
}

const [HeaderWithErrorBoundary] = [Header].map((Component) =>
  enhanceComponentWithErrorBoundary(Component),
)

const BlickPlusOfferPage: FunctionComponent<BlickPlusOfferPageProps> = ({
  Component,
  restOfPageProps,
}) => {
  return (
    <>
      <HeaderWithErrorBoundary
        removeLanguageSwitcher={true}
        forceDisableSecondLevelNavigation={true}
        forceCenter={true}
      />
      <Component {...restOfPageProps} />
      <PianoFooterBanner />
    </>
  )
}

export default BlickPlusOfferPage
